import { makeAutoObservable, runInAction } from 'mobx';
import qs from 'qs';
import history from '_app/history';
import Cookies from 'js-cookie';

import { APP_ROUTES } from '_app/routes';
import {
  region,
  appClientId,
  userPoolId,
  redirectURI,
  logoutURI,
} from '_app/awsConfig';
import {
  frontApi,
  setToken,
  API_ROUTES,
} from '_app/api';
import toast from 'utils/toast';

const ALLOWED_ROLES = ['Admin', 'Moderator']
export class AuthStore {
  constructor() {
    makeAutoObservable(this);

    this.autoLogin();
  }

  isAuthenticated = false;

  isLoading = false;

  user = {};

  profile = {};

  tokens = {};

  errors = {};

  getProfile = async () => {
    try {
      const { data } = await frontApi.get(API_ROUTES.profile.get);

      runInAction(() => {
        this.profile = data;
      })

    } catch (error) {
      console.error(error);
      this.handleLogout();
    }
  };

  login = async (formData) => {
    try {
      
      console.dir(process.env);
      const { data } = await frontApi.post(API_ROUTES.login, formData);

      const { accessToken, expiresIn, user } = data;

      const isAllowed = ALLOWED_ROLES.includes(user.role);

      if (!isAllowed) {
        toast({
          title: 'Not allowed',
          status: 'error'
        })
      } else {
        setToken(accessToken);
        Cookies.set('token', accessToken, { expires: 10 });
        Cookies.set('loggedProfileId', user.profile);
        Cookies.set('userId', user.id);

        await this.getProfile();

        runInAction(() => {
          this.user = user;
          this.isAuthenticated = true;
        });

        history.push(APP_ROUTES.HOME);
      }


      return null;
    } catch (error) {
      console.warn(error);
      return error;
    }
  };

  autoLogin = async () => {
    const accessToken = Cookies.get('token');
    const profileId = Cookies.get('loggedProfileId');

    if (accessToken && profileId) {
      setToken(accessToken);

      try {
        await this.getProfile();

        runInAction(() => {
          this.isAuthenticated = true;
          this.user = {};
        })

        // console.log('eee')
        history.push(APP_ROUTES.HOME);
      } catch (error) {

      }
    }
  }

  handleLogout = async () => {
    Cookies.remove('token');
    Cookies.remove('loggedProfileId');
    Cookies.remove('userId');
    this.isAuthenticated = false;
    this.user = {};
    this.profile = {};
  };
}

export default new AuthStore();
